import React, { Component, Fragment } from 'react';
import DataTable from 'react-data-table-component';
import { controlRole } from '../../common/actions/controlRole';
import { isEmpty, isNil, isNull, withNavigate } from '../../utility';
import MyTooltip from '../../common/tooltip';
import './style.scss';

import SelectorCopy from '../../common/selectorCopy';
import Loading from '../../common/loading';
import CSVExport from '../../common/csvExport';

import FormFiltersDeviceAccess from '../components/formFiltersDeviceAccess';
import expanableComponentLoginInfo from '../components/expanableComponentDeviceAccess';

class DeviceAccess extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loadingForRole: true,
            isLoading: false,

            openFilters: true,
            openFiltersDesktop: false,

            type: '',
            modal: false
        }

        this.setLoading = this.setLoading.bind(this);
        this.toggleModal = this.toggleModal.bind(this);
    }

    /**
     * Il mount e l'update sono uguali, poiche se navigo tra i link di react router, dopo aver
     * caricato questa pagina, esegue solo il mount, mentre se refresho la pagina carica l'update.
     * 
     * (Esempio: se vado una prima volta sulla pagina utenti, dopo il mount carica update.
     * Se dopo il caricamento, senza refreshare, navigo e vado ad altre parti, esempio player, e poi ritorno,
     * react carica solo il mount e nemmeno una volta update.)
     */
    componentDidMount() {
        // se l'utente non ha nessun permesso per visualizzare le info per device, viene rispedito alla home
        if (!isEmpty(this.props.role.player)) {
            if (!controlRole(this.props.role.player, "api/Player/LoginsInfoByDevice", "GET")) {
                this.props.handleNavigation(this.props.navigate, `/`);
                this.props.infoNotify('Non hai nessun permesso per visualizzare gli ip!')
            } else {
                if (this.state.loadingForRole) {
                    this.setState({ loadingForRole: false });
                }
            }
        }
    }

    componentDidUpdate() {
        // se l'utente non ha nessun permesso per visualizzare le info per device, viene rispedito alla home
        if (!isEmpty(this.props.role.player)) {
            if (!controlRole(this.props.role.player, "api/Player/LoginsInfoByDevice", "GET")) {
                this.props.handleNavigation(this.props.navigate, `/`);
                this.props.infoNotify('Non hai nessun permesso per visualizzare gli ip!')

            } else
                if (this.state.loadingForRole) {
                    this.setState({ loadingForRole: false });
                }
        }

        if (!localStorage.token) {
            this.props.handleNavigation(this.props.navigate, '/');
        }
    }

    setLoading = (value) => {
        this.setState({ isLoading: value });
    }

    /**
     * Dato un ID device, vai alla schermata dei device portando id player nei filtri
    */
    goToPlayer = (player) => {
        this.props.setIdPlayerForDetail(player);
        this.props.handleNavigation(this.props.navigate, `/player/devices`);
    }

    toggleModal = () => {
        this.setState({
            modal: false,
            titleModal: '',
            type: ''
        });
    }

    render() {
        const { player, role } = this.props;

        const columns = [
            {
                name: 'Device Id',
                selector: row =>
                    <Fragment>
                        <span className="clickGoTo" onClick={() => { this.goToPlayer(row.deviceId) }} style={{ marginRight: '10px' }}>
                            <MyTooltip
                                title="Vai a questo Device ID"
                                position="top"
                                content={<i className="fas fa-share-square"></i>}
                            />
                        </span>
                        <SelectorCopy item={row.deviceId} infoNotify={this.props.infoNotify} />
                    </Fragment>
            },
            {
                name: 'IP Distinti',
                selector: row => {
                    if (isNull(row.details)) return "-";

                    const ips = [...new Set(row.details.map(d => d.ip))];

                    return ips.length <= 1
                        ? ips[0]
                        : (
                            <MyTooltip
                                title={
                                    ips.map((ip, index) => (
                                        <ul key={index} style={{ margin: '0.5vh', paddingLeft: '10px', fontSize: '16px' }}>
                                            <li>{ip}</li>
                                        </ul>
                                    ))
                                }
                                position="top"
                                content={<span className="moreProd">More IPs</span>}
                            />
                        );
                }
            },
            {
                name: 'Tot Ip',
                maxWidth: '100px',
                center: true,
                selector: row => {
                    if (!row.ips || row.ips.length === 0) return "-";

                    return (
                        <MyTooltip
                            title={
                                row.ips.map((ip, index) => (
                                    <ul key={index} style={{ margin: '0.5vh', paddingLeft: '10px', fontSize: '16px' }}>
                                        <li>{ip}</li>
                                    </ul>
                                ))
                            }
                            position="top"
                            content={<span>{row.ips.length}</span>}
                        />
                    );
                }
            },
            {
                name: 'Tot uA',
                maxWidth: '100px',
                center: true,
                selector: row => {
                    if (!row.uas || row.uas.length === 0) return "-";

                    return (
                        <MyTooltip
                            title={
                                row.uas.map((ua, index) => (
                                    <ul key={index} style={{ margin: '0.5vh', paddingLeft: '10px', fontSize: '16px' }}>
                                        <li>{ua}</li>
                                    </ul>
                                ))
                            }
                            position="top"
                            content={<span>{row.uas.length}</span>}
                        />
                    );
                }
            }
        ];

        const customStyles = {
            rows: {
                style: {
                    minHeight: '50px',
                }
            },
            headCells: {
                style: {
                    paddingLeft: '8px',
                    fontWeight: 600,
                },
            },
            headRow: {
                style: {
                    minHeight: '35px',
                },
            },
            cells: {
                style: {
                    paddingLeft: '8px',
                },
            },
        };

        return (
            <Fragment>
                {
                    this.state.loadingForRole ? <Loading /> :
                        <Fragment>
                            <div className="row">
                                <div className="col-12 licenceDesktop">
                                    <div className="contentFilterSearch">
                                        <FormFiltersDeviceAccess
                                            player={player}
                                            role={role}

                                            getLoginInfo={this.props.getLoginInfoDevice}

                                            warningNotify={this.props.warningNotify}
                                            infoNotify={this.props.infoNotify}
                                            errorNotify={this.props.errorNotify}
                                            successNotify={this.props.successNotify}
                                        />
                                    </div>

                                    <div className="contentUser">
                                        <div className="row titleMobile">
                                            <div className="col-6">
                                                <h2 className='inlineBlock'>Accessi per Device</h2>
                                            </div>

                                            {
                                                !isNil(player.listLoginInfoDevice) &&
                                                <div className="col-6 text-end">
                                                    <CSVExport
                                                        data={player.listLoginInfoDevice}
                                                        filename="list-logins-device.csv"
                                                        label="Scarica la lista dei login per device"
                                                    />
                                                </div>
                                            }
                                        </div>

                                        <div className="row">
                                            <div className="col-12">
                                                <hr />
                                                <DataTable
                                                    columns={columns}
                                                    data={player.listLoginInfoDevice}
                                                    customStyles={customStyles}
                                                    noHeader
                                                    striped
                                                    highlightOnHover
                                                    pointerOnHover
                                                    clearSelectedRows
                                                    expandableRows={player.isLoading ? false : true}
                                                    expandOnRowClicked
                                                    expandableRowsComponent={expanableComponentLoginInfo}
                                                    expandableRowsComponentProps={{
                                                        "getLoginInfo": this.props.getLoginInfoDevice,
                                                        "setIdPlayerForDetail": this.props.setIdPlayerForDetail,
                                                        "handleNavigation": this.props.handleNavigation,
                                                        "errorNotify": this.props.errorNotify,
                                                        "successNotify": this.props.successNotify,
                                                        "infoNotify": this.props.infoNotify
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    {(player.isLoading || player.isLoadingChange || this.state.isLoading) && <Loading />}
                                </div>
                            </div>
                        </Fragment>
                }

            </Fragment>
        )
    }
}

export default withNavigate(DeviceAccess);